var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { checkIfSearchable, useResourceSearchDropdown, } from 'ziphy-web-shared/basic/entities/notes/resources';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { Dropdown, DropdownContent } from 'ziphy-web-shared/basic/lib/functional';
import { useInitialSelected, useSelectMacroDropdown } from '../../Notes.hooks';
import { $notes } from '../../Notes.store';
import styles from './MacrosPlus.module.scss';
const MacrosPlus = ({ $section, macrosList, parentBlockRef, className, buttonClassName, }) => {
    const isRoot = !Boolean(parentBlockRef);
    const { dropdown, macro, setMacro, isMulti, triggerModal } = useSelectMacroDropdown({
        $section,
        macrosList,
        onSelect: useCallback((macroId) => __awaiter(void 0, void 0, void 0, function* () {
            yield $notes.runMacro({ sectionId: $section.id, macroId, parentBlockRef });
        }), [$section.id, parentBlockRef]),
        isTextBlock: true,
    });
    const initialSelected = useInitialSelected(macro);
    const onSelectResource = useCallback((fhirRef) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const refAsString = Array.isArray(fhirRef) ? fhirRef.join(',') : fhirRef;
        if (!refAsString)
            return (_a = dropdown.dropdownRef.current) === null || _a === void 0 ? void 0 : _a.setIsOpen(false);
        const isInsert = isRoot && (!$section.isMayHaveChildren || macro.type === 'resources');
        const response = isInsert
            ? yield $notes.insertBlock({
                sectionId: $section.id,
                content: `%%${macro.id}:${refAsString}%%`,
                parentBlockRef,
            })
            : yield $notes.runMacro({
                sectionId: $section.id,
                macroId: macro.id,
                parentBlockRef,
                fhirRef: refAsString,
            });
        if (!response.error) {
            (_b = dropdown.dropdownRef.current) === null || _b === void 0 ? void 0 : _b.setIsOpen(false);
        }
    }), [macro, parentBlockRef, isRoot]);
    const { resourceSearchDropdown, isAddingNew, selectedItems, handleOnDone, handleOnReset, handleOnRemoveAll, handleOnRemove, contentMountEventName, openResourceModal, } = useResourceSearchDropdown({
        encounterId: $section.encounterId,
        resourceContext: macro === null || macro === void 0 ? void 0 : macro.properties,
        initialSelected,
        isMulti,
        practiceSettings: $section.practiceSettings,
        onSelectResource,
    });
    const isSearchable = macro ? checkIfSearchable(macro.properties.searchPreference) : null;
    useEffect(() => isSearchable === false && openResourceModal(''), [triggerModal]);
    if (dropdown.totalItems === 0) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(Dropdown, Object.assign({ ref: dropdown.dropdownRef, renderButton: ({ fieldRef, onToggle }) => (_jsx(Button, { ref: fieldRef, mode: ['secondary-icon', 'xs', 'justIcon'], onClick: onToggle, leftElement: 'plus', className: buttonClassName })), onClickOutside: isAddingNew ? () => { } : undefined, onOpen: () => {
            if (!macro && dropdown.totalItems === 1) {
                const first = dropdown.filteredItems[0].items[0];
                if (first.extra.type === 'resource')
                    first.onClick();
            }
        }, onAfterClose: () => {
            setMacro(null);
            dropdown.setSearchString('');
            resourceSearchDropdown.setSearchString('');
        }, className: classNames(styles.dropdown, className), resizeDeps: [
            macro === null || macro === void 0 ? void 0 : macro.id,
            dropdown.searchString,
            dropdown.totalFilteredItems,
            resourceSearchDropdown.searchString,
            resourceSearchDropdown.totalFilteredItems,
        ] }, { children: isSearchable ? (_jsx(DropdownContent, { searchField: {
                value: resourceSearchDropdown.searchString,
                onChange: resourceSearchDropdown.setSearchString,
            }, isLoading: resourceSearchDropdown.isLoading, items: resourceSearchDropdown.filteredItems, isManualCloseControl: true, isMulti: isMulti, 
            // selectedItems={selectedItems}
            onDone: handleOnDone, onRemoveAll: handleOnRemoveAll, onRemoveItem: handleOnRemove, mountEventName: contentMountEventName, onOpen: () => {
                var _a;
                if (!isMulti && (initialSelected === null || initialSelected === void 0 ? void 0 : initialSelected.length)) {
                    onSelectResource(initialSelected);
                    (_a = dropdown.dropdownRef.current) === null || _a === void 0 ? void 0 : _a.setIsOpen(false);
                }
            } }, 'resources')) : (_jsx(DropdownContent, { searchField: dropdown.totalItems > 1
                ? { value: dropdown.searchString, onChange: dropdown.setSearchString }
                : undefined, isManualCloseControl: true, items: dropdown.filteredItems }, 'marcos')) })));
};
export default observer(MacrosPlus);
